module.exports = __webpack_public_path__ + "img/car-dealership-icon.241f5b45.svg";